import React from 'react';

export const KeycardKey = () => (
  <svg width="50" height="16" viewBox="0 0 50 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M49.9762 5.96678L49.9649 5.96732V5.91182L17.3107 5.89122L14.4865 0.00612686V0H3.83066L0 7.98252L3.83066 15.965H14.4865V15.9589L17.3107 10.1236H33.7305L31.6767 14.2746L35.5313 16L38.3729 10.1236H41.7697L39.7159 14.2746L43.5706 16L46.4122 10.1236H50L49.9762 5.96678ZM11.8144 11.8107H6.49994L4.63175 7.98245L6.49994 4.15431H11.8144L13.6825 7.98245L11.8144 11.8107Z"
      fill="var(--keycard-key-color)"
    />
  </svg>
);
